// extracted by mini-css-extract-plugin
module.exports = {"leftSideBar":"styles_leftSideBar__1uaSF","optionBtn":"styles_optionBtn__1izmC","rightBox":"styles_rightBox__34IoM","emptyImg":"styles_emptyImg__2-ZhN"};